import { Container } from "unstated";
import api from "api";
import user from "./user";
import _ from 'lodash';
import mapValuesAsync from 'utils/mapValuesAsync';
import microtasks from "utils/microtaskMap";

const DEFAULT_STATE = {
  summary: "",
  summaryIsLoading: true,
  challenges: [],
  challengesLoading: true,
  education: [],
  educationLoading: true,
  workExperience: [],
  workExperienceLoading: true,
  impactTasks: [],
  impactTasksLoading: true,
  skills: [],
  skillsLoading: true,

  requirements: [],
  requiremenstIsLoading: [],
  taskStatuses: {}
};

const TYPES = {
  challenge: "Challenge",
  education: "Qualification",
  workExperience: "Job",
  impactTasks: "Assignment",
  skill: "Skill",
};

class DashboardProvider extends Container {
  constructor() {
    super();
    this.state = DEFAULT_STATE;
  }

  loadDashboardData() {
    // this.getSummary();
    // this.getChallenges();
    // this.getEducation();
    // this.getWorkExperience();
    // this.getImpactTasks();
    // this.getSkills();

    this.getEsdData();
    this.getTaskStatuses();
  }

  async getEsdData() {
    console.log('@@@ user.state.profile: ', user.state.profile);
    await api.business.get(user.state.profile?.parent_partner_id, user.state.profile?.partner_id, user.state.profile?.my_uuid_id).on('value', snapshot => {
      const data = snapshot.val();
      if (!_.isNil(data?.business_requirements)) {
        this.setState({
          requirements: data.business_requirements,
          requirementsIsLoading: false,
        });
      }
      if (!_.isNil(data?.mentors)) {
        this.setState({
          mentors: data.mentors,
        });
      }
      if (!_.isNil(data?.mentorship_sessions)) {
        this.setState({
          mentorship_sessions: data.mentorship_sessions,
        });
      }
    });
  }

  async getTaskStatuses() {
    const statuses = await mapValuesAsync(microtasks, async opportunity_id => {
      try {
        const res = await api.tasks.check(opportunity_id);
        console.log('@@@ res: ', res);
        return res;
      } catch(e) {
        console.log('@@@ error retrieving task status: ', e);
        return {}
      }
    });

    console.log('@@@ statuses: ', statuses);

    this.setState({
      taskStatuses: statuses,
    });
  }

  async getSummary() {
    await api.users
      .getById(user.state.id)
      .then(async (response) => {
        const user = response.data;
        this.setState({
          summary: user.biography || "",
          summaryIsLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          summaryIsLoading: false,
        });
      });
  }

  async getChallenges() {
    await api.users.credentials
      .getByType(user.state.id, TYPES.challenge)
      .then(async (response) => {
        const challenges = await this.mapResponse(response, TYPES.challenge);
        this.setState({
          challenges,
          challengesLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          challengesLoading: false,
        });
      });
  }

  async getEducation() {
    await api.users.credentials
      .getByType(user.state.id, TYPES.education)
      .then(async (response) => {
        const education = await this.mapResponse(response, TYPES.education);
        this.setState({
          education: education || [],
          educationLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          educationLoading: false,
        });
      });
  }

  async getWorkExperience() {
    await api.users.credentials
      .getByType(user.state.id, TYPES.workExperience)
      .then(async (response) => {
        const workExperience = await this.mapResponse(
          response,
          TYPES.workExperience
        );
        this.setState({
          workExperience,
          workExperienceLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          workExperienceLoading: false,
        });
      });
  }

  async getImpactTasks() {
    await api.users.credentials
      .getByType(user.state.id, TYPES.impactTasks)
      .then(async (response) => {
        const impactTasks = await this.mapResponse(response, TYPES.impactTasks);
        this.setState({
          impactTasks,
          impactTasksLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          impactTasksLoading: false,
        });
      });
  }

  async getSkills() {
    await api.users.skills
      .getAll(user.state.id)
      .then(async (response) => {
        const skills = await this.mapSkills(response);
        this.setState({
          skills,
          skillsLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          skillsLoading: false,
        });
      });
  }

  async mapSkills(response) {
    const result = Object.values(
      (response.data || []).reduce((acc, cur) => {
        if (cur.skillName in acc) {
          cur.verifiedBy && acc[cur.skillName].verifiers.push(cur.verifiedBy);
          return acc;
        }

        acc[cur.skillName] = {
          skillName: cur.skillName,
          verifiers: cur.verifiedBy ? [cur.verifiedBy] : [],
        };

        return acc;
      }, {})
    );
    return result;
  }

  async mapResponse(response, name) {
    const obj = response.data || [];
    const mappedArr = [];
    obj.forEach((o) => {
      mappedArr.push({
        ...o,
        credentialId: o.id,
        ...o[name.toLowerCase()],
      });
    });
    return mappedArr;
  }
}

export default DashboardProvider;
